/**
 * text-with-cta.js
 *
 * GSAP ScrollTrigger reveal for the text-with-cta section.
 */

class TextWithCtaSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._wrap = this.querySelector('[data-twc-reveal]');
    this._init();
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.contains(this)) { this._teardown(); this._init(); }
    });
  }

  disconnectedCallback() { this._teardown(); }

  _init() {
    if (!this._wrap) return;
    
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
       console.warn('GSAP or ScrollTrigger not found');
       return;
    }
    gsap.registerPlugin(ScrollTrigger);

    const l1 = this._wrap.querySelector('.c-twc__line--1');
    const l2 = this._wrap.querySelector('.c-twc__line--2');
    const l3 = this._wrap.querySelector('.c-twc__line--3');
    const cta = this.querySelector('.c-twc__cta');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: 'top 95%',
        end: 'bottom 65%',
        scrub: 1,
        invalidateOnRefresh: true
      }
    });

    if (l1) tl.to(l1, { opacity: 1, y: 0, duration: 0.3, ease: 'none' }, 0);
    if (l2) tl.to(l2, { opacity: 1, y: 0, duration: 0.3, ease: 'none' }, 0.2);
    if (l3) tl.to(l3, { opacity: 1, y: 0, duration: 0.3, ease: 'none' }, 0.4);
    if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.25, ease: 'none' }, 0.75);

    this._gsapTimeline = tl;
  }

  _teardown() {
    if (this._gsapTimeline) {
      this._gsapTimeline.scrollTrigger?.kill();
      this._gsapTimeline.kill();
      this._gsapTimeline = null;
    }
    
    // Clear GSAP styles
    const elements = this.querySelectorAll('.c-twc__line, .c-twc__cta');
    elements.forEach(el => gsap.set(el, { clearProps: 'all' }));
  }
}

if (!customElements.get('text-with-cta-section')) {
  customElements.define('text-with-cta-section', TextWithCtaSection);
}
